import { BenefitsControllerService } from "@9amhealth/openapi";
import { Blac, Cubit } from "blac-next";
import reportErrorSentry from "src/lib/reportErrorSentry";
import { KnownProgram } from "src/state/ProgramBloc/ProgramBloc";
import TaskManagementBloc from "src/state/TaskManagementBloc/TaskManagementBloc";

export enum RecurringLabStep {
  Intro = "intro",
  Questionnaire = "questionnaire",
  MedicalInsurance = "medicalInsurance"
}

interface RecurringLabQuestionnaireCubitState {
  activeStep: RecurringLabStep;
  medicalInsuranceAvailable: boolean;
}

export default class RecurringLabQuestionnaireCubit extends Cubit<RecurringLabQuestionnaireCubitState> {
  constructor() {
    super({
      activeStep: RecurringLabStep.Intro,
      medicalInsuranceAvailable: false
    });
    void this.updateInsuranceAvailability();
  }

  updateInsuranceAvailability = async () => {
    try {
      const response = await BenefitsControllerService.getBenefits();
      const medicalInsurances = response.data.medicalInsurances ?? [];
      this.patch({
        medicalInsuranceAvailable: medicalInsurances.length > 0
      });
    } catch (error) {
      reportErrorSentry(error);
    }
  };

  nextStep = () => {
    const { activeStep, medicalInsuranceAvailable } = this.state;
    if (activeStep === RecurringLabStep.Intro) {
      if (medicalInsuranceAvailable) {
        this.patch({ activeStep: RecurringLabStep.Questionnaire });
      } else {
        this.patch({ activeStep: RecurringLabStep.MedicalInsurance });
      }
    } else if (activeStep === RecurringLabStep.MedicalInsurance) {
      this.patch({ activeStep: RecurringLabStep.Questionnaire });
    }
  };

  handleMedicalInsuranceSaved = () => {
    if (this.state.activeStep !== RecurringLabStep.MedicalInsurance) {
      return;
    }
    void Blac.getBloc(TaskManagementBloc).loadProgramTasks(
      KnownProgram.ONBOARDING
    );
    this.nextStep();
  };
}
